import { mockData } from './Mock';

mockData.set('getRedisConfigs', [
  {
    key: 'praise:high_quality_threshold',
    name: '口碑墙最低价',
    value: '1000',
  },
]);

mockData.set('setPraiseWallMinPrice', true);

mockData.set('getSmsCodeStatus', {
  phoneNumber: '13800138000',
  verificationCode: '1234',
  codeType: '1',
  expired: false,
});

mockData.set('sendSmsCode', true);
